import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { FileUploader } from 'react-drag-drop-files';
import { Col, Container, Row } from 'react-bootstrap';
import doctor from '../../Assets/dr-online.svg';
import fileIcon from '../../Assets/upload-icon.svg';
import { BASE_URL as API_URL } from '../../utils/apiBase';
import ContextHelper from '../../ContextHooks/ContextHelper';

const FolderUpload = () => {
  const { currentUser } = ContextHelper();
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const token = currentUser?.token;

  const handleFileChange = async (file) => {
    setFile(file);
    await uploadFile(file);
  };

  const uploadFile = async (file) => {
    if (!file) {
      toast.error('Please select a file to upload');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('history', 'Test History');

    try {
      setUploading(true);
      // const response = await axios.post(`${API_URL}uploadcase`, formData, {
      //   timeout: 0,
      // });

      const response = await axios.post(`${API_URL}uploadcase`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        timeout: 0,
      });


      setUploadSuccess(true);

      setTimeout(() => {
        setUploadSuccess(false);
        setFile(null);
      }, 2000);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <section className="bg-white p-4 min-vh-100 shadow-sm d-flex align-items-center justify-content-center">
        <Container fluid>
          <Row className="align-items-center">
            <Col lg={6} className="text-center">
              <img src={doctor} alt="Doctor" className="img-fluid" width={400} height={400} />
            </Col>
            <Col lg={4}>
              <h2 className="text-center mb-4 base-color fw-bold">Upload a File Attachment</h2>
              <div className="w-100">
                <FileUploader
                  multiple={false}
                  handleChange={handleFileChange}
                  name="file"
                  classes="drag-area rounded-3 flex-column d-flex justify-content-center align-items-center"
                >
                  <div className="icon">
                    <img src={fileIcon} alt="Upload" />
                  </div>
                  <p className="my-2">Drag & Drop to Upload File</p>
                  <span className="or">OR</span>
                  <p className="btn base-color-bg text-white fw-semibold mt-4">Browse Report</p>
                  {file && <p className="fs-16 mb-0 mt-3">{file.name || ''}</p>}
                </FileUploader>
              </div>
              {uploading && (
                <div className="d-flex justify-content-center align-items-center mt-3">
                  <div className="spinner-border base-color me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span className="fs-5">Uploading...</span>
                </div>
              )}
              {uploadSuccess && (
                <div className="alert alert-success mt-3" role="alert">
                  File uploaded successfully!
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FolderUpload;
